export default __webpack_public_path__ + "static/media/Level20.e34eded7.svg";